import { ISaveSettingsAction } from './settingsActions';

export type SettingsActionTypes = ISaveSettingsAction;

export enum SettingsActionTypeKeys {
    SAVE_SETTINGS = 'SETTINGS/SAVE_SETTINGS',
}


// WEBPACK FOOTER //
// ./src/actions/settingsActionTypes.ts